export const POST_SHOW_RESET = 'POST_SHOW_RESET'
export const POST_SHOW_SET_ERROR = 'POST_SHOW_SET_ERROR'
export const POST_SHOW_SET_RETRIEVED = 'POST_SHOW_SET_RETRIEVED'
export const POST_SHOW_TOGGLE_LOADING = 'POST_SHOW_TOGGLE_LOADING'
